import React, { useState } from "react";
import Loader from "../reusble_components/loader";
import { apiLink } from "../../helpers/constantVariables";
import { apiDelete } from "../../api/api_methods";

export default function DeleteAccountWithhId() {
  const [loading, setloading] = useState(false);
  const [isAccountDeleted, setIsAccountDeleted] = useState(false);
  const [id, setId] = useState("");

  const deleteAccountWithId = (gid) => {
      const deleteUser = async (id) => {
        if (id === "") {
          alert("Please enter a valid id");
        } else {
          const response = await apiDelete(`/user/delete-with-id/${id}`);
          if (response.status === 200) {
            alert(`${response.body?.message}`);
            localStorage.clear();
          } else {
            alert(`Failed to delete account. Status: ${response.body.message}`);
          }
        }
      };
      
      // Call the function with the appropriate id
      deleteUser(id);
  };

 

  return (
    <div className="gil-reg flex flex-col items-center justify-center h-[100vh] w-[90%] mx-auto md:w-full">
      <Loader loader={loading} />
      <p className="text-3xl">Delete account</p>
      <p className="mb-4 text-center">
        Click on Delete Account button after enter your id to delete your account
      </p>
      {!isAccountDeleted ? (
       <div className="flex flex-col gap-5 md:w-[20%]">
        <input type="text" name="email" className="p-2 px-4 border-2 rounded-md" placeholder="Enter Your Id" onChange={(e) => {setId(e.target.value); console.log(id)}}/>
        <button className="gil-reg text-lg bg-primary text-white px-4 py-2 rounded-md shadow-md hover:shadow-lg focus:outline-none" onClick={deleteAccountWithId}>
            Delete Account
        </button>
       </div>
      ) : (
        <div className="flex flex-col items-center justify-center">
          <p className="text-2xl text-green-600">
            Account deleted successfully
          </p>

          <a href="/" className="gil-reg text-lg mt-4 underline">
            Go to home
          </a>
        </div>
      )}
    </div>
  );
}
